export default __webpack_public_path__ + "static/media/protocolgen2.ee3cd389.png";